{
	"approveContract": "Approuver le contrat",
	"description": "Vous avez des accords en cours.",
	"deselectAllContracts": "Désélectionner tous les contrats",
	"modalApproveConfirmation": {
		"description": "Pour finaliser l'abonnement et confirmer l'approbation, nous enverrons un code à l'e-mail enregistré. À la fin de l'abonnement, vous ne pourrez annuler qu'en contactant le canal d'assistance.",
		"header": "Confirmation d'approbation",
		"reminder": "Rappel : vérifiez votre dossier spam, l'email avec le code peut lui avoir été dirigé.",
		"sendCode": "Envoyer le code"
	},
	"modalCodeConfirmation": {
		"codePlaceholder": "Entrez le code envoyé",
		"confirmSign": "confirmer l'abonnement",
		"description": "Entrez le code de confirmation pour terminer la signature de la demande.",
		"verifyCode": "Code de confirmation"
	},
	"request": "Demande #{{request}}",
	"selectAllContracts": "Sélectionnez tous les contrats",
	"title": "Termes et contrats en attente"
}
